import React from 'react';
import ResourceLink from './ResourceLink';

const ResourceItem = ({ title, description, href }) => (
    <div className="border-t border-[#e8e6e3] py-3.5 first:border-t-0 first:pt-0">
        <h3 className="text-[14px] leading-5 font-medium text-[#2d2d2d]">
            {title}
        </h3>
        <p className="mt-1 text-[12px] leading-[18px] text-[#6b6b6b]">
            {description}
        </p>
        <div className="mt-2">
            <ResourceLink href={href} />
        </div>
    </div>
);

export default ResourceItem;
